import { DataType } from "./AnalyticsTracker";
import { LoginResponseUser } from "@api-types/user/LoginResponseDto";

export class XtremePushProvider {
	private isXtremeEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("xp-web");
	}

	constructor() {}

	public setUserId(userData: LoginResponseUser) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		if (!userData) {
			console.error("Missing user data from local storage");
			return;
		}

		try {
			if (!userData.id || !userData.userNumericalId) {
				console.error("Missing userId or numerical id");
				return;
			}

			window.xtremepush?.(
				"set",
				"user_id",
				`${userData.userNumericalId}_${userData.id}`
			);
		} catch (error) {
			console.error("Error with shooting xtremepush setUserId", error);
			return;
		}
	}

	public trackPageView(eventName: string, url: string) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		window.xtremepush?.("event", eventName, {
			url: url,
			title: document.title,
		});
	}

	public trackEvent(eventName: string, data: DataType) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		window.xtremepush?.("event", eventName, {
			source: "web",
			...data,
		});
	}
}
